import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import React from "react";
import ContestBack from "Assets/Images/ContestBack.png";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate, useParams } from "react-router-dom";

const RedirectingDialog = ({ open, setOpen, type = "redirect" }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  const { id } = useParams();

  const data = {
    redirect: {
      title: "Redirecting in 10 seconds",
      description:
        "Your request has been Approved! Please wait while we redirect you to the test or click the button below.",
      button: "Start Contest",
    },
    test: {
      title: "Test Already Attempted",
      description:
        "It seems you have already taken this test. You will have to wait for 46 hours before taking another attempt. If issue still persists, please contact",
      button: "ok",
    },
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <Box
        sx={(theme) => ({
          backgroundImage: `url(${ContestBack})`,
          margin: "16px",
          borderRadius: "8px",
          padding: "16px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "bottom",
        })}
      >
        <IconButton
          sx={{ marginLeft: "auto", display: "flex" }}
          onClick={() => handleClose()}
        >
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            width="16px"
            height="16px"
          />
        </IconButton>
        <Box
          width={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={"16px"}
          textAlign={"center"}
          padding={"60px 0px"}
        >
          <Typography
            display={"flex"}
            justifyContent={"center"}
            variant="title"
            fontWeight={500}
            color="white"
          >
            {data?.[type]?.["title"]}
          </Typography>
          <Typography color="white">{data?.[type]?.["description"]}</Typography>
          <Button
            color="white"
            sx={{ width: "fit-content", margin: "auto" }}
            variant="outlined"
            onClick={() => {
              handleClose();
              navigate(`/test/${id}/index`);
            }}
          >
            {data?.[type]?.["button"]}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RedirectingDialog;
